import React, { createContext, useContext } from "react";
import { AccountHolderRatePlan } from "../../../services/accountService";
import { RatePlan } from "../../../pages/customerSettings/RatePlans";

export type RatePlansContextType = {
  /* Manually specified Rate Plans including country-specific configurations */
  definedRatePlans: RatePlan[];
  /* Rate Plans specific to each account holder and country of origin merged with definedRatePlans */
  definedAccountHolderRatePlans: RatePlan[];
  /* AccountHolderRatePlans for each account holder coming from the server */
  accountHolderRatePlans: AccountHolderRatePlan[];
  /* Modified AccountHolderRatePlans that differ from the initial state */
  modifiedRatePlans: AccountHolderRatePlan[];
  /* Function to modify the context */
  modify: (update: RatePlan, changes: Partial<AccountHolderRatePlan>) => void;
  /* Resets the Rate Plans back to their initial state before modification */
  reset: () => void;
  /* Indicates if the Save button should be enabled based on required fields */
  saveButtonEnabled: boolean;
  /* Function to update the rate plan type */
  updateRatePlanType: (newType: string) => void;
};

export const RatePlansContext = createContext<RatePlansContextType | null>(
  null
);

// Convenience hook for consuming the context
export function useRatePlansContext() {
  const context = useContext(RatePlansContext);
  if (!context) {
    throw new Error(
      "useRatePlansContext must be used within a RatePlansProvider"
    );
  }
  return context;
}
